module.exports = __webpack_public_path__ + "static/media/cookie-bite.7fcc47f9.svg";